import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { cloneDeep, groupBy, isEmpty } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetQueryV3Mutation } from 'store/features/api/graphSlice';
import {
	useGetPGRListMutation,
	useGetControlListMutation,
	useGetDynaFormPropertyListMutation,
	useGetServiceLevelListByStatusMutation,
	useGetConditionMasterValidationListMutation,
} from 'store/features/comptroller/comptrollerApi';
import {
	useGetAllProcessMutation,
	useGetCompanyInfoMutation,
	useSolutionTaskListMutation,
	useGetProcessPositionMutation,
	useGetOrgstructureListMutation,
	useLynConditionApprovalMutation,
	useGetHRFunctionMasterListMutation,
	useGetEmployeeListByCompanyCodeMutation,
} from 'store/features/process/processApi';

function removeActionConditions(data) {
	return {
		...data,
		taskConditionPeople: data?.taskConditionPeople?.map((task) => ({
			...task,
			conditionPeopleSet: task?.conditionPeopleSet?.map((conditionSet) => ({
				...conditionSet,
				lynApprovalConditions: conditionSet?.lynApprovalConditions?.filter((condition) => condition.key !== 'action'),
			})),
		})),
	};
}

export const timestamp = [
	{
		label: 'Hour (s)',
		value: 'hour',
	},
	{
		label: 'Day (s)',
		value: 'day',
	},
	{
		label: 'Week (s)',
		value: 'week',
	},
];

export const assignmentTypeOption = [
	{
		label: 'Employee',
		value: 'userId',
	},
	{
		label: 'Process Role',
		value: 'processPositionId',
	},
	{
		label: 'Position',
		value: 'positionId',
	},
	{
		label: 'Person Field',
		value: 'personField',
	},
	{
		label: 'Supervisor',
		value: 'supervisor',
	},
	{
		label: 'Creator',
		value: 'creator',
	},
	// {
	//   label: "System",
	//   value: "system",
	// },
	{
		label: 'Function',
		value: 'functionId',
	},
	{
		label: 'Skip',
		value: 'skip',
	},
	{
		label: 'Process Group Role',
		value: 'pgr',
	},
	{
		label: 'Committee',
		value: 'committee',
	},
	{
		label: 'Form Person List',
		value: 'formPersonList',
	},
	{
		label: 'Identity Field',
		value: 'identityField',
	},
];

export const operandOption = [
	{
		value: 'EQUAL',
		label: '=',
		name: 'Equals to',
	},
	{
		value: 'NOT_EQUAL',
		label: '!=',
		name: 'Not equals to',
	},
	{
		value: 'GREATER_THAN',
		label: '>',
		name: 'Greater than',
	},
	{
		value: 'LESS_THAN',
		label: '<',
		name: 'Less than',
	},
	{
		value: 'GREATER_THAN_EQUAL',
		label: '>=',
		name: 'Greater than or equals to',
	},
	{
		value: 'LESS_THAN_EQUAL',
		label: '<=',
		name: 'Less than or equals to',
	},
];

const useSolutionConditionHook = ({ form }) => {
	const state = useLocation();
	const navigate = useNavigate();

	const { profileData } = useSelector((state) => state?.profile);

	const processCode = form?.getFieldValue('processCode');
	const processVersion = form?.getFieldValue('processVersion');

	const [PGR, setPGR] = useState([]);
	const [SLAList, setSLAList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [reRender, setReRender] = useState(true);
	const [structure, setStructure] = useState(null);
	const [nameOption, setNameOption] = useState([]);
	const [submitData, setSubmitData] = useState(null);
	const [taskDetails, setTaskDetails] = useState([]);
	const [submitForm, setSubmitForm] = useState(false);
	const [prevIndexMap, setPrevIndexMap] = useState({});
	const [mapInputType, setMapInputType] = useState([]);
	const [conditionTask, setConditionTask] = useState([]);
	const [submitButton, setSubmitButton] = useState(true);
	const [controlListMap, setControlListMap] = useState([]);
	const [solutionOption, setSolutionOption] = useState([]);
	const [positionOptions, setPositionOptions] = useState(null);
	const [finalPeopleOptions, setFinalPeopleOptions] = useState([]);
	const [functionMasterOptions, setFunctionMasterOptions] = useState(null);
	const [processPositionOptions, setProcessPositionOptions] = useState(null);
	const [code, setCode] = useState({
		code: null,
		taskActionTaken: null,
	});
	const [processValue, setProcessValue] = useState({
		processCode: '',
		processVersion: '',
	});
	const [stateValues, setStateValues] = useState({
		editList: null,
		peopleOption: [],
	});

	const { editList, peopleOption } = stateValues;
	// const { processCode, processVersion } = processValue;

	const [GetPGRList] = useGetPGRListMutation();
	const [getQueryV3, { data: getCommitteeList }] = useGetQueryV3Mutation();
	const [getAllProcess, { data: solutionList }] = useGetAllProcessMutation();
	const [GetControlList, { data: controlList }] = useGetControlListMutation();
	const [GetCompanyInfo, { data: companyInfoList }] = useGetCompanyInfoMutation();
	const [GetEmployeeListByCompanyCode] = useGetEmployeeListByCompanyCodeMutation();
	const [SolutionTaskList, { data: allSolutionTask }] = useSolutionTaskListMutation();
	const [GetProcessPosition, { data: getProcessList }] = useGetProcessPositionMutation();
	const [GetOrgstructureList, { data: getListOrgStructure }] = useGetOrgstructureListMutation();
	const [LynConditionApproval, { data: lynConditionApproval }] = useLynConditionApprovalMutation();
	const [GetDynaFormPropertyList, { data: dynaFormPropertyList }] = useGetDynaFormPropertyListMutation();
	const [GetHRFunctionMasterList, { data: hrFunctionMasterList }] = useGetHRFunctionMasterListMutation();
	const [GetConditionMasterValidationList, { data: lynConditionValidation }] = useGetConditionMasterValidationListMutation();
	const [
		GetServiceLevelListByStatus,
		{ data: getServiceLevelListByStatus, isSuccess: isGetServiceLevelListByStatusSuccess, isError: isGetServiceLevelListByStatusError },
	] = useGetServiceLevelListByStatusMutation();

	const inputArray = ['input', 'number', 'text', 'hradio', 'radio', 'select', 'date', 'checkbox', 'file', 'textarea', 'currency', 'integer'];

	const dropDownLabel = {
		userId: 'Employee',
		processPositionId: 'Process Role',
		positionId: 'Position',
		personField: 'Person Field',
		formPersonList: 'Form Person List',
		identityField: 'Flexible Field',
		supervisor: 'Supervisor',
		creator: 'Creator',
		system: 'System',
		skip: 'Skip',
		functionId: 'Function',
		pgr: 'Process Group Role',
		committee: 'Committee',
	};

	useEffect(() => {
		async function fetchData() {
			const res = await GetPGRList({
				companyCode: profileData?.creatorOrganizationId,
			});

			if (res?.data?.status === 'SUCCESS') {
				const pgrList = res?.data?.list;
				const pgrOptionList = pgrList?.map((item) => ({
					label: item?.name,
					value: item?.id,
				}));

				setPGR(pgrOptionList);
			}
		}

		if (profileData?.creatorOrganizationId) {
			fetchData();
		}
	}, [profileData?.creatorOrganizationId]);

	useEffect(() => {
		async function fetchData() {
			const res = await GetEmployeeListByCompanyCode({
				parentCode: profileData?.creatorOrganizationId,
			});

			const employeeList = res.data;

			if (employeeList) {
				const arr = [];

				for (let i = 0; i < employeeList?.length; i++) {
					arr.push({
						label: employeeList[i]?.entityFullName + ' (' + employeeList[i]?.entityCode + ')',
						value: employeeList[i]?.entityCode,
						id: 'userId',
					});
				}

				setStateValues((prev) => ({
					...prev,
					peopleOption: arr,
				}));
			}
		}

		if (profileData?.creatorOrganizationId) {
			fetchData();
		}
	}, [profileData?.creatorOrganizationId]);

	useEffect(() => {
		if (state?.state) {
			setStateValues((prev) => ({
				...prev,
				editList: state?.state?.editList,
			}));
		}
	}, [state?.state]);

	const committee = useMemo(() => {
		if (!getCommitteeList?.results?.length) return [];

		return (
			getCommitteeList?.results?.map((item, index) => ({
				label: item?.displayName,
				value: item?.propertyValue,
				id: index,
			})) || []
		);
	}, [getCommitteeList]);

	useEffect(() => {
		if (peopleOption || processPositionOptions || positionOptions || nameOption || functionMasterOptions || PGR || committee) {
			let finalArray = {
				userId: peopleOption,
				processPositionId: processPositionOptions,
				positionId: positionOptions,
				personField: nameOption,
				formPersonList: nameOption,
				identityField: nameOption,
				functionId: functionMasterOptions,
				pgr: PGR,
				supervisor: [
					{
						label: 'Supervisor 1',
						value: 'supervisor-1',
						code: 'supervisor',
					},
					{
						label: 'Supervisor 2',
						value: 'supervisor-2',
						code: 'supervisor',
					},
					{
						label: 'Supervisor 3',
						value: 'supervisor-3',
						code: 'supervisor',
					},
				],
				creator: [
					{
						label: 'Creator',
						value: 'creator',
					},
				],
				system: [
					{
						label: 'System',
						value: 'system',
					},
				],
				skip: [
					{
						label: 'Skip',
						value: 'skip',
					},
				],
				committee: committee,
			};
			setFinalPeopleOptions(finalArray);
		}
	}, [positionOptions, processPositionOptions, peopleOption, nameOption, functionMasterOptions, PGR, committee]);

	useEffect(() => {
		if (controlList) {
			const arr = [];
			const arr1 = [];

			for (let i = 0; i < controlList?.lynSolutionTaskFormDetailsList?.length; i++) {
				if (
					inputArray.includes(controlList?.lynSolutionTaskFormDetailsList[i]?.type.toLowerCase()) &&
					controlList?.lynSolutionTaskFormDetailsList[i]?.elementSettings?.toLowerCase() !== 'control'
				) {
					if (!controlList?.lynSolutionTaskFormDetailsList[i]?.code.includes('PROPERTY_actionOption')) {
						arr.push({
							label: controlList?.lynSolutionTaskFormDetailsList[i]?.label
								? controlList?.lynSolutionTaskFormDetailsList[i]?.label
								: controlList?.lynSolutionTaskFormDetailsList[i]?.altLabel,
							value: controlList?.lynSolutionTaskFormDetailsList[i]?.code,
							type: controlList?.lynSolutionTaskFormDetailsList[i]?.type.toLowerCase(),
							id: 'personField',
						});
						arr1[controlList?.lynSolutionTaskFormDetailsList[i]?.code] = controlList?.lynSolutionTaskFormDetailsList[i]?.type;
					}
				}
			}

			setMapInputType(arr1);
			setNameOption(arr);
		}
	}, [controlList]);

	useEffect(() => {
		if (dynaFormPropertyList) {
			const arr = [];
			const arr1 = [];

			dynaFormPropertyList?.lynProperties?.map((item) => {
				arr.push({
					label: item?.displayName,
					value: item?.propertyValue,
					code: item?.propertyCode,
				});

				arr1[item?.propertyCode] = item;

				return item;
			});

			setControlListMap(groupBy(arr, ({ code }) => code));
		}
	}, [dynaFormPropertyList]);

	useEffect(() => {
		if (getProcessList) {
			const arr = [];

			getProcessList?.lynPositionList
				?.filter((fItem) => fItem.activationStatus === 'Active')
				.map((item) => {
					arr.push({
						label: item?.positionCode,
						value: item?.id,
						id: 'processPositionId',
					});
					return item;
				});

			setProcessPositionOptions(arr);
		}
	}, [getProcessList]);

	useEffect(() => {
		GetServiceLevelListByStatus({
			activationStatus: 'Active',
		});

		if (profileData?.creatorOrganizationId) {
			getQueryV3({
				companyCode: profileData?.creatorOrganizationId,
				name: 'getCommitteeDD',
			});
		}
	}, [profileData?.creatorOrganizationId]);

	useEffect(() => {
		if (getServiceLevelListByStatus?.lynSLADefinitions?.length > 0) {
			setSLAList(getServiceLevelListByStatus?.lynSLADefinitions);
		}
	}, [isGetServiceLevelListByStatusError, isGetServiceLevelListByStatusSuccess]);

	useEffect(() => {
		if (getListOrgStructure) {
			const arr = [];

			getListOrgStructure?.lynOrgStructModelDetails
				?.filter((fItem) => fItem.activationStatus === 'Active')
				.map((item) => {
					arr.push({
						label: item?.positionName + ' (' + item?.positionId + ')',
						value: item?.id,
						id: 'positionId',
					});
					return item;
				});

			setPositionOptions(arr);
		}
	}, [getListOrgStructure]);

	useEffect(() => {
		if (hrFunctionMasterList && companyInfoList) {
			const layerNameMap = companyInfoList?.lynCompanyInfo?.reduce((acc, item) => {
				if (item?.layerNumber) {
					acc[item.layerNumber] = item.name;
				}

				return acc;
			}, {});

			const arr = [];

			hrFunctionMasterList?.lynFunctionMaster?.map((item) => {
				arr.push({
					label: item?.name + ' (' + layerNameMap[item?.layerNumber] + ')',
					value: item?.id,
					id: 'functionId',
				});

				return item;
			});
			setFunctionMasterOptions(arr);
		}
	}, [hrFunctionMasterList]);

	const renderForm = async (data, id) => {
		form.setFieldValue('id', data?.id);
		form.setFieldValue('status', data?.status);
		form.setFieldValue('processCode', data?.processCode);
		form.setFieldValue('conditionName', data?.conditionName);
		form.setFieldValue('processVersion', data?.processVersion);
		form.setFieldValue('conditionVersion', data?.conditionVersion);
		form.setFieldValue('effectiveDate', data?.effectiveDate?.dateString);
		form.setFieldValue('conditionVersionLabel', `${data?.processVersion}.${data?.conditionVersion}`);

		let prevIndexMap = {};

		data?.taskConditionPeople?.forEach((item, index) => {
			form.setFieldValue(['taskConditionPeople', index, 'solutionTaskCode'], item?.solutionTaskCode);
			form.setFieldValue(['taskConditionPeople', index, 'taskActionTaken'], item?.taskActionTaken);

			prevIndexMap[item?.solutionTaskCode] = item?.conditionPeopleSet?.length;

			item?.conditionPeopleSet?.forEach((nestItem, key) => {
				const filteredLynApprovalConditions = nestItem?.lynApprovalConditions?.filter(
					(nestnestItem) => !nestnestItem?.key?.includes('action')
				);

				filteredLynApprovalConditions?.map((nestnestItem, nestKey) => {
					form.setFieldValue(
						['taskConditionPeople', index, 'conditionPeopleSet', key, 'lynApprovalConditions', nestKey, 'key'],
						nestnestItem?.key
					);

					form.setFieldValue(
						['taskConditionPeople', index, 'conditionPeopleSet', key, 'lynApprovalConditions', nestKey, 'operation'],
						nestnestItem?.operation
					);

					form.setFieldValue(
						['taskConditionPeople', index, 'conditionPeopleSet', key, 'lynApprovalConditions', nestKey, 'operand'],
						nestnestItem?.operand
					);

					return nestnestItem;
				});

				nestItem?.lynApprovalPeopleSerial?.map((nestnestItem, nestKey) => {
					form.setFieldValue(
						['taskConditionPeople', index, 'conditionPeopleSet', key, 'lynApprovalPeopleSerial', nestKey, 'flow'],
						nestnestItem?.flow
					);

					form.setFieldValue(
						['taskConditionPeople', index, 'conditionPeopleSet', key, 'lynApprovalPeopleSerial', nestKey, 'value'],
						nestnestItem?.value
					);

					form.setFieldValue(
						['taskConditionPeople', index, 'conditionPeopleSet', key, 'lynApprovalPeopleSerial', nestKey, 'peopleOf'],
						nestnestItem?.peopleOf
					);

					return nestnestItem;
				});

				form.setFieldsValue({
					taskConditionPeople: {
						[index]: {
							conditionPeopleSet: {
								[key]: {
									lynApprovalSLA: {
										slaCode: nestItem?.lynApprovalSLA?.slaCode,
										slaId: nestItem?.lynApprovalSLA?.slaId,
										duration: nestItem?.lynApprovalSLA?.duration,
										unit: nestItem?.lynApprovalSLA?.unit,
									},
								},
							},
						},
					},
				});
			});
		});

		GetConditionMasterValidationList({
			id: id,
		});
		setPrevIndexMap(prevIndexMap);
	};

	useEffect(() => {
		if (lynConditionValidation?.length && prevIndexMap) {
			const groupedTasks = groupBy(
				lynConditionValidation?.filter((task) => task.conditionPeopleSet.length > 0),
				'solutionTaskCode'
			);

			const result = isValidated(lynConditionValidation);

			if (result) {
				setLoading(false);
				setSubmitButton(false);
			} else {
				setSubmitButton(true);
				validateConditionMaster(groupedTasks);
			}
		} else {
			setLoading(false);
		}
	}, [lynConditionValidation, prevIndexMap]);

	const isValidated = (lynApprovalConditions) => {
		const taskCodeMap = {};

		for (const task of lynApprovalConditions) {
			const { solutionTaskCode, conditionPeopleSet } = task;

			if (!Object.hasOwn(taskCodeMap, solutionTaskCode)) {
				taskCodeMap[solutionTaskCode] = true;
			}

			if (Array.isArray(conditionPeopleSet) && conditionPeopleSet.length !== 0) {
				taskCodeMap[solutionTaskCode] = false;
			}
		}

		return Object.values(taskCodeMap).every((isEmpty) => isEmpty);
	};

	useEffect(() => {
		if (lynConditionApproval?.status === 'SUCCESS') {
			form.resetFields();

			if (!submitButton && submitForm) {
				toast.success('Success! Action completed.', toastConfig);

				setSubmitForm(false);
				setLoading(false);

				navigate('/comptroller/condition-master');
			} else {
				renderForm(removeActionConditions(lynConditionApproval?.modelConditionMaster), lynConditionApproval?.id);
			}
		} else if (lynConditionApproval?.status === 'FAILED') {
			toast.error('Failure! Action not completed.', toastConfig);

			setSubmitForm(false);
			setLoading(false);

			navigate('/comptroller/condition-master');
		}
	}, [lynConditionApproval, submitData]);

	const conditionNameGenerate = (val) => {
		if (solutionOption) {
			for (let i = 0; i < solutionOption?.length; i++) {
				if (solutionOption[i]?.value === val) {
					setProcessValue({
						processCode: solutionOption[i]?.value,
						processVersion: solutionOption[i]?.version,
					});

					form.setFieldValue('processVersion', solutionOption[i]?.version);
					form.setFieldValue('conditionVersionLabel', solutionOption[i]?.version + '.01');
					return solutionOption[i]?.label;
				}
			}
		}
	};

	useEffect(() => {
		getAllProcess({});
		GetOrgstructureList({});
		GetProcessPosition({});
		GetHRFunctionMasterList({});
		GetCompanyInfo({});
	}, []);

	useEffect(() => {
		if (profileData && (processValue || editList)) {
			if (processCode && processVersion) {
				SolutionTaskList({
					companyCode: profileData?.creatorOrganizationId,
					processCode: processCode,
					processVersion: processVersion,
				});

				GetControlList({
					companyCode: profileData?.creatorOrganizationId,
					processCode: processCode,
					processVersion: processVersion,
				});

				GetDynaFormPropertyList({
					companyCode: profileData?.creatorOrganizationId,
					fieldCode: processCode,
					processVersion: processVersion,
				});
			} else if (editList) {
				SolutionTaskList({
					companyCode: profileData?.creatorOrganizationId,
					processCode: editList?.processCode,
					processVersion: editList?.processVersion,
				});

				GetControlList({
					companyCode: profileData?.creatorOrganizationId,
					processCode: editList?.processCode,
					processVersion: editList?.processVersion,
				});

				GetDynaFormPropertyList({
					companyCode: profileData?.creatorOrganizationId,
					fieldCode: editList?.processCode,
					processVersion: editList?.processVersion,
				});
			}
		}
	}, [profileData, processCode, editList]);

	useEffect(() => {
		if (allSolutionTask && !editList) {
			const arr = [];
			const arr2 = [];
			const solutionTaskMap = {};

			setCode({
				code: allSolutionTask?.lynSolutionTaskDetails[0]?.code,
				taskActionTaken: allSolutionTask?.lynSolutionTaskDetails[0]?.taskActionTaken,
			});

			allSolutionTask?.lynSolutionTaskDetails?.forEach((solutionTask, index) => {
				if (solutionTask?.processCode === processCode && index !== 0 && solutionTask?.taskCode !== 'TC-Task_Action') {
					arr.push({
						solutionTaskCode: solutionTask?.code,
						taskActionTaken: solutionTask?.taskActionTaken,
						conditionPeopleSet: [
							{
								lynApprovalConditions: [{ key: undefined, operation: undefined, operand: undefined }],
								lynApprovalPeopleSerial: [{ flow: undefined, peopleOf: undefined, value: undefined }],
								lynApprovalSLA: { slaCode: undefined, duration: undefined, unit: undefined },
							},
						],
					});

					solutionTaskMap[solutionTask?.code] = solutionTask?.taskName;

					arr2.push(solutionTask?.code);
				}
			});

			form.setFieldValue('taskConditionPeople', arr);

			setStructure(arr);
			setTaskDetails(arr2);
			setConditionTask(solutionTaskMap);
		}
	}, [allSolutionTask, processCode]);

	useEffect(() => {
		if (editList && mapInputType && allSolutionTask !== undefined) {
			const arr2 = [];
			const solutionTaskList = {};

			form.setFieldValue('id', editList?.id);
			form.setFieldValue('status', editList?.status);
			form.setFieldValue('processCode', editList?.conditionName);
			form.setFieldValue('conditionName', editList?.conditionName);
			form.setFieldValue('processVersion', editList?.processVersion);
			form.setFieldValue('conditionVersion', editList?.conditionVersion);
			form.setFieldValue('effectiveDate', editList?.effectiveDate?.dateString);
			form.setFieldValue('conditionVersionLabel', `${editList?.processVersion}.${editList?.conditionVersion}`);

			setCode({
				code: allSolutionTask?.lynSolutionTaskDetails?.[0]?.code,
				taskActionTaken: editList?.startSolutionTaskAction,
			});

			const taskConditionMap = groupBy(editList?.taskConditionPeople, 'solutionTaskCode');

			allSolutionTask?.lynSolutionTaskDetails?.forEach((solutionTask, index) => {
				if (solutionTask?.processCode === editList?.processCode && index !== 0 && solutionTask?.taskCode !== 'TC-Task_Action') {
					solutionTaskList[solutionTask?.code] = solutionTask?.taskName;

					arr2.push(solutionTask?.code);
				}
			});

			setTaskDetails(arr2);
			setConditionTask(solutionTaskList);

			const updatedTaskConditionPeople = editList?.taskConditionPeople
				?.filter((item) => (solutionTaskList?.[item?.solutionTaskCode] ? true : false))
				?.map((item) => {
					const updatedConditionPeopleSet = item.conditionPeopleSet?.map((nestItem) => {
						const modifiedNestItem = cloneDeep(nestItem);

						modifiedNestItem.lynApprovalConditions = modifiedNestItem.lynApprovalConditions?.filter((data) => data.key !== 'action');

						return modifiedNestItem;
					});
					return {
						...item,
						conditionPeopleSet: updatedConditionPeopleSet,
					};
				});

			setStructure(
				updatedTaskConditionPeople?.forEach((item) => {
					item?.conditionPeopleSet?.forEach((nestItem) => {
						nestItem?.lynApprovalConditions?.forEach((nestnestItem) => {
							nestnestItem.key = undefined;
							nestnestItem.operand = undefined;
							nestnestItem.operation = undefined;
						});

						nestItem?.lynApprovalPeopleSerial?.forEach((nestnestItem) => {
							nestnestItem.flow = undefined;
							nestnestItem.value = undefined;
						});

						nestItem.lynApprovalSLA = {
							slaCode: undefined,
							duration: undefined,
							unit: undefined,
						};
					});
				})
			);

			let prevIndexMap = {};
			const conditionSetValue = [];

			allSolutionTask?.lynSolutionTaskDetails?.forEach((solutionTask, index) => {
				if (index > 0 && solutionTask?.taskGroupCode !== 'TGC-Task_Action' && solutionTask?.processCode === editList?.processCode) {
					const singleConditionSet = {
						solutionTaskCode: solutionTask.code,
						taskActionTaken: solutionTask?.taskActionTaken,
						conditionPeopleSet: [],
					};

					const solutionTaskCondition = taskConditionMap?.[solutionTask?.code]?.[0];

					if (!isEmpty(solutionTaskCondition)) {
						prevIndexMap[solutionTaskCondition?.solutionTaskCode] = solutionTaskCondition?.conditionPeopleSet?.length;

						solutionTaskCondition?.conditionPeopleSet?.forEach((nestItem) => {
							const conditionPeopleSetEntry = {
								lynApprovalConditions: [],
								lynApprovalPeopleSerial: [],
								lynApprovalSLA: {
									slaCode: undefined,
									duration: undefined,
									unit: undefined,
								},
							};

							nestItem?.lynApprovalConditions?.forEach((nestnestItem) => {
								if (!nestnestItem?.key?.includes('action')) {
									conditionPeopleSetEntry.lynApprovalConditions.push({
										key: nestnestItem?.key,
										operation: nestnestItem?.operation,
										operand: nestnestItem?.operand,
									});
								}
							});

							nestItem?.lynApprovalPeopleSerial?.forEach((nestnestItem) => {
								conditionPeopleSetEntry.lynApprovalPeopleSerial.push({
									flow: nestnestItem?.flow,
									value: nestnestItem?.value,
									peopleOf: nestnestItem?.peopleOf,
								});
							});

							conditionPeopleSetEntry.lynApprovalSLA.slaCode = nestItem?.lynApprovalSLA?.slaCode;
							conditionPeopleSetEntry.lynApprovalSLA.slaId = nestItem?.lynApprovalSLA?.slaId;
							conditionPeopleSetEntry.lynApprovalSLA.duration = nestItem?.lynApprovalSLA?.duration;
							conditionPeopleSetEntry.lynApprovalSLA.unit = nestItem?.lynApprovalSLA?.unit;

							singleConditionSet.conditionPeopleSet.push(conditionPeopleSetEntry);
						});
					}

					conditionSetValue.push(singleConditionSet);
				}
			});

			form.setFieldValue('taskConditionPeople', conditionSetValue);

			setPrevIndexMap(prevIndexMap);
		}
	}, [editList, allSolutionTask, mapInputType]);

	const validation = async (data) => {
		setLoading(true);
		await onSubmit(data);
	};

	const validateConditionMaster = (data) => {
		taskDetails?.map((task, index) => {
			data[task]?.map((item) => {
				item?.conditionPeopleSet?.map((subItem, key) => {
					subItem?.lynApprovalConditions?.map((nestItem, nestKey) => {
						if (nestItem?.key !== 'action') {
							form.setFieldValue(
								[
									'taskConditionPeople',
									index,
									'conditionPeopleSet',
									prevIndexMap[task] + key,
									'lynApprovalConditions',
									nestKey,
									'key',
								],
								nestItem?.key
							);
							form.setFieldValue(
								[
									'taskConditionPeople',
									index,
									'conditionPeopleSet',
									prevIndexMap[task] + key,
									'lynApprovalConditions',
									nestKey,
									'operation',
								],
								nestItem?.operation
							);
							form.setFieldValue(
								[
									'taskConditionPeople',
									index,
									'conditionPeopleSet',
									prevIndexMap[task] + key,
									'lynApprovalConditions',
									nestKey,
									'operand',
								],
								nestItem?.operand
							);
						}
						return nestItem;
					});
					return subItem;
				});
				return item;
			});
			return task;
		});
		setReRender(!reRender);
		setLoading(false);
	};

	useEffect(() => {
		if (solutionList) {
			const arr = [];

			for (let i = 0; i < solutionList?.lynProcess?.length; i++) {
				if (solutionList?.lynProcess[i]?.activationStatus === 'W-I-P') {
					arr.push({
						label: solutionList?.lynProcess[i]?.name,
						value: solutionList?.lynProcess[i]?.processCode,
						version: solutionList?.lynProcess[i]?.version,
					});
				}
			}

			setSolutionOption(arr);
		}
	}, [solutionList]);

	const onSubmit = async (data) => {
		delete data.effectiveDate;
		delete data.conditionVersionLabel;

		data?.taskConditionPeople?.map((item) => {
			item?.conditionPeopleSet?.map((subItem) => {
				if (!subItem?.lynApprovalConditions) {
					subItem.lynApprovalConditions = [];
				}
				subItem?.lynApprovalConditions?.push({
					key: 'action',
					operation: 'EQUAL',
					operand: 'SUBMIT',
				});
				return subItem;
			});
			return item;
		});

		if (editList?.id) {
			delete data.processCode;

			const payload = {
				id: editList?.id,
				companyCode: profileData?.creatorOrganizationId,
				processCode: editList?.processCode,
				startSolutionTaskCode: code?.code,
				solutionName: editList?.conditionName,
				startTaskActionTaken: code?.taskActionTaken,
				status: editList?.status,
				...data,
			};
			LynConditionApproval(payload);
		} else {
			const payload = {
				companyCode: profileData?.creatorOrganizationId,
				processCode: data?.processCode,
				startSolutionTaskCode: code?.code,
				startTaskActionTaken: code?.taskActionTaken,
				solutionName: data?.conditionName,
				status: 'W-I-P',
				...data,
			};

			LynConditionApproval(payload);
		}
	};

	const handleValidateButtonDisabled = (filedValue) => {
		if (filedValue?.taskConditionPeople?.length > 0) {
			const value = filedValue?.taskConditionPeople?.map((item) => {
				if (item?.conditionPeopleSet?.length > 0) {
					const value = item?.conditionPeopleSet
						?.map((subItem) => (subItem?.lynApprovalPeopleSerial?.length > 0 ? false : true))
						?.includes(true)
						? true
						: false;

					return value;
				} else {
					return true;
				}
			});

			return value?.includes(true);
		} else {
			return true;
		}
	};

	useEffect(() => {
		if (submitForm && submitData) {
			onSubmit(submitData);
		}
	}, [submitForm]);

	return {
		SLAList,
		editList,
		structure,
		timestamp,
		nameOption,
		mapInputType,
		prevIndexMap,
		conditionTask,
		dropDownLabel,
		controlListMap,
		setPrevIndexMap,
		finalPeopleOptions,
	};
};

export default useSolutionConditionHook;
